<template>
	<div class="page">
		<div class="sidebar">
			<sidebar></sidebar>
		    <div class="sort" ref="sort">
		    	<div class="item">
		    		<h4 @click="showSortList">版种</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insEdition}" @click="_sortEdition(item,index)" v-for="(item,index) in sortEdition" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    	<div class="item">
		    		<h4 @click="showSortList">地区</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insArea}" @click="_sortArea(item,index)" v-for="(item,index) in sortArea" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    	<div class="item">
		    		<h4 @click="showSortList">年份</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insYear}" @click="_sortYear(item,index)" v-for="(item,index) in sortYear" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    </div>
		    <div class="sort fixed" :class="navBarFixed?'navBarWrap':''" ref="sort">
		    	<div class="item">
		    		<h4 @click="showSortList">版种</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insEdition}" @click="_sortEdition(item,index)" v-for="(item,index) in sortEdition" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    	<div class="item">
		    		<h4 @click="showSortList">地区</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insArea}" @click="_sortArea(item,index)" v-for="(item,index) in sortArea" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    	<div class="item">
		    		<h4 @click="showSortList">年份</h4>
		    		<div class="itemList" :class="navBarList?'on':''">
		    			<a href="javascript:;" :class="{active:index==insYear}" @click="_sortYear(item,index)" v-for="(item,index) in sortYear" :data-sort="item">
		    				<span>{{item}}</span>
		    			</a>
		    		</div>
		    	</div>
		    </div>
		</div>
		<div class="pageContainer">
			<div class="pageTitle">
				<h3>作品</h3>
			</div>
			<div class="pageContent">
				<div class="pageList works">
					<div class="waterfall">
						<ul>
							<li v-for="(item,index) in newboxArr" 
								:style="{width:newBoxWidth + unit, position:item.position, top:item.top + unit, left:item.left + unit}"
								:class="{active:index==insWorks}">
								<div class="box">
									<a href="javascript:;" @click="_resultShow(index)">
										<div class="img">
											<img v-lazy="item.src" :key="item.src" :alt="item.name" :data-width="item.width" :data-height="item.height"/>
										</div>
										<div class="info" ref="info">
											<h4>{{item.name}}</h4>
											<p>{{item.author}}</p>
											<p>{{item.nation}}</p>
										</div>
									</a>
								</div>
							</li>
						</ul>
		  				<div class="noData" v-show="newboxArr.length == 0">
		  					<p>暂时没有数据，请重新筛选！</p>
		  				</div>
						<div class="datails" v-show="resultShow">
				  			<a href="javascript:;" class="close" @click="close()"></a>
				  			<div class="detailsBg" @click="close()"></div>
							<div class="pageContainer">
								<div class="pageTitle">
									<h3>{{current.author}}</h3>
									<span>{{current.nation}}</span>
								</div>
								<div class="pageContent">
									<div class="result">
										<div class="img">
											<img :src="current.src" :alt="current.name" preview="current.index" />
										</div>
										<div class="info">
											<h4>{{current.name}}</h4>
											<p>{{current.MetrialCN}}</p>
											<p>{{current.size}}</p>
											<p>{{current.year}} <span v-show="current.year != ''">年</span></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import Sidebar from 'base/sidebar/sidebar'
	import {ERR_OK} from 'api/config'
	import DataList from 'data/data.json'
	import jq from 'jquery'

	export default {
		data(){
			return{
				list:[],
				newList:[],
				insWorks:-1,
				insEdition:0,
				insArea:0,
				insYear:0,
				sortEdition:['所有','凸版','凹版','平版','孔版','数码版','综合版','其他'],
				sortArea:['所有','亚洲','欧洲','北美洲','南美洲','非洲','大洋洲'],
				sortYear:[],
		    	newboxArr:[],
		    	current:[],
		    	resultShow:false,
		    	boxWidth:this.isMobile()?355:310,
		    	parentWidth:this.isMobile()?750 - ((40*document.documentElement.clientWidth)/750):document.documentElement.clientWidth - 560 - 90,
		    	maxRow:4,
				noData:false,
				unit:this.isMobile()?'rem':'px',
				newBoxWidth:0,
				navBarFixed:false,
				navBarList:true
			}
		},
		created(){
			this._getListData()
		},
		methods:{
			_getListData(){
		         let _res = DataList
		         if(_res.status === ERR_OK){
		         	delete _res.data[_res.data.Artworks]
		         	_res.data.forEach((item,index) =>{
		         		for (var i = 0; i < item.Artworks.length; i++) {
		         			let newItem = {
								"index":index,
								"src":"static/img/"+item.Artworks[i].ArtworkImage,
								"name":item.Artworks[i].TitleCN,
								"author":item.ArtistCN,
								"nation":item.ArtistNationCN,
								"region":item.ArtistRegionCN,
								"TagCN":item.Artworks[i].TagCN,
								"MetrialCN":item.Artworks[i].MetrialCN,
								"size":item.Artworks[i].Size,
								"year":item.Artworks[i].Year,
								"width":item.Artworks[i].width,
								"height":item.Artworks[i].height
							}
		         			this.list.push(newItem);
		         		}
		         	})
					this._getSortYear()
		         	this.newList = this.list;
		         	this.imgLocation();
					this.newBoxWidth = this.isMobile()?this.boxWidth/100:this.boxWidth
					this.$previewRefresh()
		         }
			},
			_getSortYear(){
				let newArr = [];
				this.list.forEach(item =>{
	             	newArr.push(item.year)
		        })
				this.sortYear = this.trimSpace(this.unique(newArr))
				this.sortYear.splice(0,0,'所有')
				
			},
			unique(arr){
				if(!Array.isArray(arr)){
					console.log('type error!')
					return;
				}
				arr = arr.sort()
				let arrry = [arr[0]];
				for (let i = 1; i < arr.length; i++) {
					if(arr[i] !== arr[i-1]){
						arrry.push(arr[i]);
					}
				}
				return arrry;
			},
			trimSpace(array){  
			     for(let i = 0 ; i < array.length; i++ ){  
			        if(array[i] == "" || array[i] == null || typeof(array[i]) == "undefined"){  
						array.splice(i,1);  
						i= i-1;  
			        }  
			     }  
			     return array;  
			},
			_sortEdition(item,num){
				let newArr = [];
				if(this.insArea == 0 && this.insYear == 0){
					newArr = this.list
				}else if(this.insArea == 0 &&  this.insYear != 0){
					newArr = this.searchYear(this.list,this.sortYear[this.insYear])
				}else if(this.insArea != 0 &&  this.insYear == 0){
					newArr = this.searchArea(this.list,this.sortArea[this.insArea])
				}else{
					let _newArr = this.searchArea(this.list,this.sortArea[this.insArea])
					newArr = this.searchYear(_newArr,this.sortYear[this.insYear])
				}

			    this.insEdition = num;
			    if(item == '所有'){
			    	this.newList = newArr
			    }else{
			    	this.newList = this.searchTagCN(newArr,item)
			    }
	         	this.imgLocation();
	         	this.showSortList();
			    this.goPost();
			},
			_sortArea(item,num){
				let newArr = [];
				if(this.insEdition == 0 && this.insYear == 0){
					newArr = this.list
				}else if(this.insEdition == 0 &&  this.insYear != 0){
					newArr = this.searchYear(this.list,this.sortYear[this.insYear])
				}else if(this.insEdition != 0 &&  this.insYear == 0){
					newArr = this.searchTagCN(this.list,this.sortEdition[this.insEdition])
				}else{
					let _newArr = this.searchTagCN(this.list,this.sortEdition[this.insEdition])
					newArr = this.searchYear(_newArr,this.sortYear[this.insYear])
				}

			    this.insArea = num
			    if(item == '所有'){
			    	this.newList = newArr
			    }else{
			    	this.newList = this.searchArea(newArr,item)
			    }
	         	this.imgLocation();
	         	this.showSortList();
			    this.goPost();
			},
			_sortYear(item,num){
				let newArr = [];
				if(this.insEdition == 0 && this.insArea == 0){
					newArr = this.list
				}else if(this.insEdition == 0 &&  this.insArea != 0){
					newArr = this.searchArea(this.list,this.sortArea[this.insArea])
				}else if(this.insEdition != 0 &&  this.insArea == 0){
					newArr = this.searchTagCN(this.list,this.sortEdition[this.insEdition])
				}else{
					let _newArr = this.searchTagCN(this.list,this.sortEdition[this.insEdition])
					newArr = this.searchArea(_newArr,this.sortArea[this.insArea])
				}

			    this.insYear = num
			    if(item == '所有'){
			    	this.newList = newArr
			    }else{
			    	this.newList = this.searchYear(newArr,item)
			    }
	         	this.imgLocation();
	         	this.showSortList();
			    this.goPost();
			},
			SkipLink(i){
				let _data = this.newList;
				this.current = _data[i];
				this.insArtist=i;
				this.currentDetail = true;
				document.body.style.overflow='hidden';
			},
			close(){
				this.current=[];
				this.resultShow = false;
				document.body.style.overflow='';
			},
			searchTagCN(Arr,keyword){
		        return Arr.filter((item,index) =>{
		          	if(item.TagCN.includes(keyword)){
			            return item
			       	}
			   })
			},
			searchArea(Arr,keyword){
		        return Arr.filter(item =>{
		          	if(item.region.includes(keyword)){
			            return item
			       	}
			   })
			},
			searchYear(Arr,keyword){
		        return Arr.filter(item =>{
		          	if(item.year.includes(keyword)){
			            return item
			       	}
			   })
			},
			imgLocation(){
				let conn = 0;
				let len = this.newList.length;
				let imgsPageHei = [];
				let maginWidth = this.isMobile()?80 : 70

				this.newList.forEach((item,index)=>{
					imgsPageHei[index]=((this.boxWidth - maginWidth)*item.height)/item.width
				})
				this.waterfall(imgsPageHei);
			},
			waterfall(imgHeiArr){
				let infoHeiArr = this._infoHeight();
				let num = this.parentWidth > this.boxWidth*this.maxRow? this.maxRow : Math.floor(this.parentWidth/this.boxWidth);
				let boxArr = [];
				this.newList.forEach((item,index) => {
					let pag = this.isMobile()?100:90;
					let boxHeight = imgHeiArr[index] + infoHeiArr[index] + pag;
					if(index < num){
						boxArr[index] = boxHeight;
						this.newList[index].position = "relative"
						this.newList[index].top = "auto"
						this.newList[index].left = "auto"
					}else{
						let minBoxHeight = Math.min.apply(null,boxArr);
						let minboxIndex = jq.inArray(minBoxHeight,boxArr);
						let minboxIndexLeft = (minboxIndex % num)*this.boxWidth;
						this.newList[index].position = "absolute"
						this.newList[index].top = this.isMobile()?minBoxHeight/100 : minBoxHeight
						this.newList[index].left = this.isMobile()?minboxIndexLeft/100 : minboxIndexLeft
						boxArr[minboxIndex] += boxHeight
					}
				})
				this.newboxArr = this.newList
			},
			_infoHeight(){
				let heightArr = [];
				this.newList.forEach((item,index) => {
					let LineHeight =  this.isMobile()? 48 : 24;
					let NameHei = this._StringLenLin(item.name.length)*LineHeight;
					let AuthorHei = this._StringLenLin(item.author.length)*LineHeight;
					let NationHei = this._StringLenLin(item.nation.length)*LineHeight;
					heightArr[index] = NameHei+AuthorHei+NationHei
				})
				return heightArr
			},
			_StringLenLin(strLen){
				let lineTxt = 1;
				let maginWidth = this.isMobile()?80 : 70;
				let fontSize = this.isMobile()? 28 : 16
				if(strLen > Math.floor((this.boxWidth - maginWidth)/fontSize)){
					lineTxt = 2
				}else{
					if(strLen == 0){
						lineTxt = 0
					}
				}
				return lineTxt
			},
			_resultShow(i){
				let _data = this.newboxArr;
				this.current = _data[i];
				this.insWorks=i;
				this.resultShow = true;
				document.body.style.overflow='hidden';
				this.$previewRefresh()
			},
		    isMobile () {
				if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
					return true // 手机端
				} else {
					return false // alert('PC端')
				}
			},
			goPost () {
		        let distance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
		        let step = distance / 30; //每步的距离
		        (function jump() {
		            if (distance > 0) {
		                distance -= step;
		                window.scrollTo(0, distance);
		                setTimeout(jump, 10);
		            }
		        })();
		    },
		    watchScroll () {
		        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		        // 当滚动超过 50 时，实现吸顶效果 
		        if (scrollTop > document.documentElement.clientHeight) { 
		        	this.navBarFixed = true 
		        } else { 
		        	this.navBarFixed = false 
		        } 
		    },
		    showSortList(){
				if(this.isMobile()){
					if(this.navBarList){
						this.navBarList = false;
					}else{
						this.navBarList = true;
					}
				}
		    }
		},
		mounted(){
			if(this.isMobile()){
				this.navBarList = false;
				window.addEventListener('scroll', this.watchScroll)
				window.addEventListener('click',e => {
			     	if(!this.$refs.sort.contains(e.target)){
			       		this.navBarList = false//点击其他区域关闭
			      	}
			    })
			}
		},
	  	components: {
	  		Sidebar
	  	}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageContainer{
		height: 100vh;
	}
	.pageContent{
		height: calc(100% - 190px);
		padding: 33px 30px;
	}

	.works{
		height: 100%;
	}

	.sort{
		width: 385px;
		position: absolute;
		top: 250px;
		left: 180px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding:0 30px 0 25px;
		border-left: 1px solid  #707070;
	}
	.sort.fixed{
		display: none;
	}
	.sort h4{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		padding-left: 5px;
	}
	.sort .item{
		margin-bottom: 24px;
	}
	.sort .itemList{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		flex-wrap: wrap;
	}
	.sort .itemList a{
		display: block;
		padding: 8px 5px;
		position: relative;
	}
	.sort .itemList a span{
		display: block;
        font-size: 16px;
		text-align: center;
		white-space: nowrap;
	}
	.sort .itemList a.active span{
        background: linear-gradient(to bottom, transparent 0%,transparent 50%,#F6EA37 51%,#F6EA37 100%);
	}
	.sort .item:last-child{
		margin-bottom: 0;
	}

	.waterfall{
		padding: 15px;
		position: relative;
	}
	.waterfall ul{
		position: relative;
	}
	.waterfall ul:after{
		display: block;
		content: '';
		visibility: hidden;
		height: 0;
		clear: both;
	}
	.waterfall li{
		position: relative;
		float: left;
		padding: 15px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.waterfall .box{
		padding: 20px;
		background-color: #EDEDED;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.waterfall .active .box{
		border-bottom: 5px solid #F6EA37 ;
	}
	.waterfall .box img{
		display: block;
		width: 100%;
		height: auto;
	}


	.waterfall .info{
		margin-top: 20px;
	}
	.waterfall h4{
		font-size: 16px;
		font-weight: 700;
		line-height: 24px;
	}
	.waterfall p{
		font-size: 16px;
		font-weight: 200;
		line-height: 24px;
	}


	.waterfall .datails{
		position: fixed;
		width: 100%;
		height: 100vh;
		top: 0;
		right: 0;
		overflow: hidden;
		z-index: 199;
	}
	.waterfall .detailsBg{
		width: 100%;
		height: 100%;
		background-color: rgba(112,112,112,.75);
	}
	.waterfall .datails .pageContainer{
		position: absolute;
		top: 0;
		right: 0;
		width: auto;
		height: 100%;
		padding-left: 40px;
		background-color: #EDEDED;
	}
	.waterfall .datails .pageTitle{
		align-items: start;
		justify-content: center;
		flex-direction: column;
	}
	.waterfall .datails .pageTitle span{
		display: block;
		margin-top: 15px;
		font-weight: 500;
		font-size: 16px;
	}
	.waterfall .datails .pageContent{
		height: calc(100% - 190px);
	}
	.waterfall .datails .pageContent .result{
		height: 100%;
		padding: 30px 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.waterfall .datails .pageContent .img{
		max-width: 70vw;
		min-width: 30vw;
		height: 70%;
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.waterfall .datails .pageContent .img img{
		display: block;
		max-width: 100%;
		max-height: 100%;
	}
	.waterfall .datails .close{
		display: block;
		width: 30px;
		height: 30px;
		position: absolute;
		top: 60px;
		right: 60px;
		background: url(~common/images/CloseBtn.svg) center/contain no-repeat;
		z-index: 10;
	}

	@media screen and (max-width:750px) {
		.pageTitle h3{
			width: calc(100% - 1rem);
		}
		.sort{
		    width: 100%;
		    position: static;
		    padding: .2rem 0;
		    border-left: 0;
		}
		.sort h4{
			font-size: .28rem;
			line-height: .48rem;
			padding-left: 5px;
		}
		.sort .itemList a{
			padding: .1rem 5px;
		}
		.sort .itemList a span{
	        font-size: .28rem;
		}
		.sort .item{
			margin-bottom: .2rem;
		}

		.sort.fixed.navBarWrap{
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			z-index: 99;
			display: -webkit-flex;
			display: -moz-flex;
			display: -ms-flex;
			display: -o-flex;
			display: flex;
			background-color: #fff;
			box-shadow: 0 1px 3px rgba(0,0,0,.2)
		}
		.sort.fixed.navBarWrap .item{
			width: 33.33%;
			margin-bottom: 0;
		}
		.sort.fixed.navBarWrap .item h4{
			text-align: center;
			border-right: 1px solid  #EDEDED;
		}
		.sort.fixed.navBarWrap .item:last-child h4{
			border-right-width: 0;
		}
		.sort.fixed.navBarWrap .itemList{
			display: none;
			width: 100%;
		}
		.sort.fixed.navBarWrap .itemList.on{
			display: -webkit-flex;
			display: -moz-flex;
			display: -ms-flex;
			display: -o-flex;
			display: flex;
		}
		.sort.fixed.navBarWrap .itemList a{
			width: 100%;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		.sort.fixed.navBarWrap .item:last-child .itemList a{
			width: 50%;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		.sort.fixe.navBarWrap .itemList a span{
			display: inline-block;
			width: auto;
			text-align: left;
		}

		.artist ul{
			align-items: start;
		}
		.artist ul li{
			width: 50%;
			margin-bottom: .2rem;
		}
		.artist ul li a span{
			font-size: .3rem;
			white-space: normal;
			line-height: 1.2;
		}
		.pageContainer{
			height: auto;
		}
		.pageContent{
			padding: 0;
		}

		.waterfall{
			padding: .2rem;
		}
		.waterfall li{
			padding: .2rem;
		}
		.waterfall .box{
			padding: .2rem;
		}
		.waterfall .active .box{
			border-bottom: .1rem solid #F6EA37 ;
		}
		.waterfall .info{
			margin-top: .2rem;
		}
		.waterfall h4{
			font-size: .28rem;
			line-height: .48rem;
		}
		.waterfall p{
			font-size: .28rem;
			line-height: .48rem;
		}
		
		.waterfall .datails .pageContainer{
			width: 100%;
			padding-left: 0;
		}
		.waterfall .datails .pageTitle{
			height: 1.2rem;
			display: block;
		}
		.waterfall .datails .pageTitle span{
			margin-top: .2rem;
			font-size: .28rem;
		}
		.waterfall .datails .pageContent{
			height: calc(100% - 2rem);
			padding: .4rem;
		}
		.waterfall .datails .pageContent .result{
			height: 100%;
			padding:0;
		}
		.waterfall .datails .pageContent .img{
			max-width: 100%;
			min-width: 30vw;
			height: 80%;
		}
		.waterfall .datails .close{
			width: .4rem;
			height: .4rem;
			top: .4rem;
			right: .4rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/works/works.vue